import { MaintenanceNotificationDto } from 'types/maintenanceNotification';
import { portalAPI } from './portalAPI';

const APIMaintenanceNotificationsSlice = portalAPI
    .enhanceEndpoints({ addTagTypes: ['ActiveMaintenance'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getActiveMaintenanceNotifications: builder.query<MaintenanceNotificationDto[], void>({
                query: () => '/v1/maintenance/active',
                providesTags: ['ActiveMaintenance'],
            }),
        }),
        overrideExisting: false,
    });

export const { useGetActiveMaintenanceNotificationsQuery } = APIMaintenanceNotificationsSlice;
